var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"download-btn",attrs:{"type":"button"},on:{"click":_vm.download}},[_vm._v(" Download ")])])}
var staticRenderFns = []

export { render, staticRenderFns }